import { Button, Card, Checkbox, Drawer, Group, Stack, Text } from '@mantine/core';
import { hasLength, useForm } from '@mantine/form';
import { ToppingResponse } from '@models/response/category';
import { memo } from 'react';
import { useDispatch } from 'react-redux';
import { v4 as uuidV4 } from 'uuid';
import { FormattedPrice } from '../../../../../../components/common/data-display/price';
import cartSlice from '../../../../../../reducers/cart';
import { AppDispatch } from '../../../../../../stores';
import { safeString } from '../../../../../../utils/stringUtil';
import { SelectToppingsModalProps } from '../../../types';

const SelectToppingsModal = ({ opened, onClose, toppingCategories, menuItem }: SelectToppingsModalProps) => {
  const dispatch: AppDispatch = useDispatch();

  const initialValues: any = {};
  const validate: any = {};

  toppingCategories?.forEach((item) => {
    initialValues[safeString(item?.id)] = [];
    if (item?.min && item.min > 0) {
      validate[safeString(item?.id)] = hasLength(
        { min: item.min, max: item.max },
        `حداقل ${item.min} مورد و حداکثر ${item.max} مورد از ${item.title} انتخاب کنید.`
      );
    }
  });

  const form = useForm({
    initialValues,
    validate,
  });

  const renderToppingLabel = (topping: ToppingResponse) => (
    <Group>
      <Text>{topping.title}</Text>
      <FormattedPrice price={topping?.price || 0} />
    </Group>
  );

  const toppingCategoriesCheckboxes = toppingCategories.map((category) => (
    <Card key={category.id}>
      <Checkbox.Group {...form.getInputProps(safeString(category?.id))} label={<Text pb="xl">{category.title}</Text>}>
        <Stack>
          {category?.toppings?.map((topping) => (
            <Checkbox key={topping.id} value={safeString(topping.id)} label={renderToppingLabel(topping)} />
          ))}
        </Stack>
      </Checkbox.Group>
    </Card>
  ));

  const onCreateOrderClick = (userInputs: { [key: string]: string[] }) => {
    const selectedToppings = Object.values(userInputs).flat();
    const allToppings = toppingCategories.flatMap((category) => category.toppings);
    const selectedItems = allToppings.filter((topping) => selectedToppings.includes(safeString(topping?.id)));

    const orderItemToppings = (selectedItems as ToppingResponse[]).map(({ title, price, id: toppingId }) => ({
      title,
      price,
      toppingId,
      count: 1,
    }));

    const orderItem = {
      ...menuItem,
      count: 1,
      temporaryOrderId: uuidV4(),
      orderItemToppings,
    };

    dispatch(cartSlice.actions.createOrder(orderItem));

    form.reset();

    onClose();
  };

  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position="bottom"
      transitionProps={{ transition: 'slide-up' }}
      title="انتخاب افزودنی ها"
      zIndex={201}
    >
      <form
        onSubmit={form.onSubmit((values) => {
          onCreateOrderClick(values);
          form.reset();
        })}
        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        <Stack spacing="xs" sx={{ overflowY: 'auto', flexGrow: 1 }}>
          {toppingCategoriesCheckboxes}
        </Stack>

        <Button type="submit" fullWidth sx={{ position: 'sticky', bottom: 0, left: 0, right: 0 }}>
          ادامه
        </Button>
      </form>
    </Drawer>
  );
};

export default memo(SelectToppingsModal);
